import React, { useState } from "react";
import "./Careers.css";
import CareerModal from "../components/CareerModal.js";
import {
  FiTrendingUp,
  FiHome,
  FiDollarSign,
  FiBookOpen,
  FiSmile,
  FiHeart,
  FiArrowRight,
  FiBriefcase
} from "react-icons/fi";

import { PrimaryCta } from "../components/CtaSystem";

const CareersPage = () => {
  const [isCareerModalOpen, setIsCareerModalOpen] = useState(false);

  return (
    <div className="careers-page-container">
      {/* Sophisticated Dark Navy Hero Section */}
      <section className="careers-hero-section">
        <div className="careers-hero-content">
          <span className="careers-eyebrow">
            <FiBriefcase className="eyebrow-icon" /> CAREERS
          </span>
          <h1>Join Our Mission</h1>
          <p>
            Join a forward-thinking team committed to transforming complex data into clear, actionable insights for businesses and financial institutions.
          </p>
        </div>
      </section>

      {/* Main Join Our Mission Section */}
      <section className="why-join-section">
        <div className="why-join-container">
          <div className="why-join-text">
            <h2>Join Our Mission</h2>
            <p>
              At Data Bolta Hai, we believe in <strong>empowering our team</strong> with cutting-edge tools and technologies.
              Our <strong>collaborative environment</strong> ensures every employee has the opportunity to <strong>grow, learn, and innovate</strong>.
              We provide a <strong>flexible work culture</strong>, competitive benefits, and <strong>continuous learning programs</strong> to help
              you reach your full potential.
            </p>
            <button className="careers-cta-btn" onClick={() => setIsCareerModalOpen(true)}>
              Connect Now! <FiArrowRight className="btn-arrow" />
            </button>
          </div>

          <div className="why-join-image-wrapper">
            <img src="/join-our-mission.png" alt="Join Our Mission at Data Bolta Hai" />
          </div>
        </div>
      </section>

      {/* Perks & Benefits Section */}
      <section className="perks-section">
        <div className="perks-container">
          <h2 className="perks-heading">Why Join Data Bolta Hai?</h2>
          <div className="perks-grid">
            <div className="perk-card">
              <span className="perk-icon"><FiTrendingUp /></span>
              <span className="perk-label">Growth Opportunities</span>
            </div>
            <div className="perk-card">
              <span className="perk-icon"><FiHome /></span>
              <span className="perk-label">Work from Home Flexibility</span>
            </div>
            <div className="perk-card">
              <span className="perk-icon"><FiDollarSign /></span>
              <span className="perk-label">Competitive Salaries</span>
            </div>
            <div className="perk-card">
              <span className="perk-icon"><FiBookOpen /></span>
              <span className="perk-label">Learning & Development</span>
            </div>
            <div className="perk-card">
              <span className="perk-icon"><FiSmile /></span>
              <span className="perk-label">Fun Work Culture</span>
            </div>
            <div className="perk-card">
              <span className="perk-icon"><FiHeart /></span>
              <span className="perk-label">Health Benefits</span>
            </div>
          </div>
        </div>
      </section>

      {/* Careers Conversion CTA */}
      <PrimaryCta
        eyebrow="CAREER OPPORTUNITIES"
        heading="Ready to build the future of financial data tech?"
        description="Join our talented team at Data Bolta Hai and work on cutting-edge GST reconciliation and enterprise analytics platforms."
        primaryBtnText="Apply Now / Connect"
        onPrimaryClick={() => setIsCareerModalOpen(true)}
        secondaryBtnText="Contact Us"
        secondaryBtnLink="/contact-us"
      />

      {/* Career Modal */}
      <CareerModal isOpen={isCareerModalOpen} onClose={() => setIsCareerModalOpen(false)} />
    </div>
  );
};

export default CareersPage;
